// utils/validations/validateForm.js  (add below imports)

import validationMessages from "./validationMessages";

/**
 * Returns either a single error string (first missing rule) or
 * an array of all missing rule messages when aggregate === true.
 *
 * @param {string} pw
 * @param {boolean} aggregate
 * @returns {string|null} or {string[]}
 */
export function getPasswordValidationError(pw, aggregate = false) {
  const msgs = validationMessages.password;
  const missing = [];

  if (typeof pw !== 'string' || pw.length < 8) {
    missing.push(msgs.tooShort());
  }
  if (!/[A-Z]/.test(pw)) {
    missing.push(msgs.missingUpper());
  }
  if (!/[a-z]/.test(pw)) {
    missing.push(msgs.missingLower());
  }
  if (!/\d/.test(pw)) {
    missing.push(msgs.missingNumber());
  }
  if (!/[@$!%*?&]/.test(pw)) {
    missing.push(msgs.missingSpecial());
  }

  if (missing.length === 0) return null;
  return aggregate ? missing : missing[0]; // return first missing by default
}
